/**
 * @generated SignedSource<<a9ca4e9c51e57e95bc81a4248e473031>>
 * @relayHash e04a594e81e7edf1963f206f7555e2aa
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID e04a594e81e7edf1963f206f7555e2aa

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "Files",
    "kind": "LinkedField",
    "name": "files",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "envVar",
        "value": "OMG_GENERATION_IS_ENABLED"
      }
    ],
    "kind": "ScalarField",
    "name": "env",
    "storageKey": "env(envVar:\"OMG_GENERATION_IS_ENABLED\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OmgQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OmgQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e04a594e81e7edf1963f206f7555e2aa",
    "metadata": {},
    "name": "OmgQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "56e92be6ec8235eaefda9d28cd64e452";

export default node;
